import { Fragment, FunctionalComponent, h } from 'preact';
import { List, ListItem, Section } from '../List';
import { PaddedTitle, Unformatted } from './LegalDescriptionFormatter.styles';
import { VerticalSpacer } from '../Spacers/VerticalSpacer';
import { getFormatedLegalDescription } from '../../modules/helpers';
import { memo } from 'preact/compat';

type Props = {
  description: string;
  descriptionTitle?: string;
  legalDescription?: string;
};

const LegalDescriptionFormatter: FunctionalComponent<Props> = memo(
  ({ description, descriptionTitle, legalDescription = '' }) => {
    // The regex captures all non-empty lines from the description
    const lines = getFormatedLegalDescription(legalDescription);

    return (
      <Section>
        {descriptionTitle && <PaddedTitle>{descriptionTitle}</PaddedTitle>}
        <ListItem>{description}</ListItem>
        {legalDescription && (
          <Fragment>
            <VerticalSpacer custom={4} />
            <List noPadding>
              {(lines &&
                typeof lines !== 'string' &&
                lines.map((line) => {
                  return (
                    <Fragment>
                      <PaddedTitle>{line.title}</PaddedTitle>
                      {line.bulletPoints.map((bp) => {
                        return (
                          <ListItem showBulletPoints addMargin>
                            {bp}
                          </ListItem>
                        );
                      })}
                    </Fragment>
                  );
                })) || <Unformatted>{legalDescription}</Unformatted>}
            </List>
          </Fragment>
        )}
      </Section>
    );
  },
);

export default LegalDescriptionFormatter;
